import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Contact_US = () => {
  return (
    <>

      <div className="contact-sec">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="contact_heading">
                <h5>Contact Us</h5>
              </div>
            </Col>

            {/* PHONE */}
            <Col lg={4} md={6} sm={12}>
              <div className="contact_card">
                <div className="icon_box">
                  <i className="bi bi-telephone-fill"></i>
                </div>
                <h4>Phone</h4>
                <p>+91 XXXXXXXXX</p>
              </div>
            </Col>

            {/* EMAIL */}
            <Col lg={4} md={6} sm={12}>
              <div className="contact_card">
                <div className="icon_box">
                  <i className="bi bi-envelope-fill"></i>
                </div>
                <h4>Email</h4>
                <p>thenaturalayurveda@gmail.com</p>
              </div>
            </Col>

            {/* ADDRESS */}
            <Col lg={4} md={12} sm={12}>
              <div className="contact_card">
                <div className="icon_box">
                  <i className="bi bi-geo-alt-fill"></i>
                </div>
                <h4>Address</h4>
                <p>
                  Nankiana Sahib Rd, Mubarik Mehal Colony, Sangrur, Punjab 148001
                </p>
              </div>
            </Col>

            <Row className="row_Frm">
              <Col lg={8} md={10}>
                <div className="contact_form_box">
                  <h2 className="form_heading">Get in Touch</h2>

                  <form>
                    <Row>
                      <Col md={6}>
                        <div className="form_group">
                          <input type="text" required />
                          <label>Your Name</label>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="form_group">
                          <input type="email" required />
                          <label>Your Email</label>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="form_group">
                          <input type="text" required />
                          <label>Phone Number</label>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="form_group">
                          <input type="text" required />
                          <label>Subject</label>
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="form_group textarea_group">
                          <textarea rows="5" required></textarea>
                          <label className="text_l">Your Message</label>
                        </div>
                      </Col>

                      <Col md={12}>
                        <button className="send_btn">Send Message</button>
                      </Col>
                    </Row>
                  </form>
                </div>
              </Col>
            </Row>

          </Row>
        </Container>
      </div>


      <div className="contact_map">
        <iframe
          src="https://maps.google.com/maps?q=Sangrur%20Punjab%20148001&t=&z=13&ie=UTF8&iwloc=&output=embed"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
          loading="lazy"
          title="location"
        ></iframe>
      </div>

    </>
  );
};
export default Contact_US;
